import { Navigate } from "react-router-dom";
import { Spinner } from "@volca/ui/components/ui/spinner";
import { Stack } from "@volca/ui/components/ui/stack";
import { useAuth } from "@/core/auth";
import { useGetMyUser } from "@/user/query";
import { isApOnly } from "@/user/utils";

export const PublicRoute = ({ children }: { children: React.ReactNode }) => {
  const { isAuthenticated, isLoading } = useAuth();
  const { data: user, isLoading: isUserLoading } = useGetMyUser();

  if (isLoading || (isAuthenticated && isUserLoading)) {
    return (
      <Stack gap={4} className="h-full w-full" justify="center" align="center">
        <Spinner layout="centered" aria-label="Loading page" />
      </Stack>
    );
  }

  // Let the protected route recover an authenticated session with no user.
  if (isAuthenticated && (!user || isApOnly(user.role))) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};
